import { Property } from "@/types/property";

interface PropDetailsDisclaimerProps {
  property: Property;
}

const PropDetailsDisclaimer = ({ property }: PropDetailsDisclaimerProps) => {
  const realtorName =
    property?.realtor?.first_name || property?.realtor?.last_name
      ? `${property?.realtor?.first_name ?? ""} ${property?.realtor?.last_name ?? ""}`.trim()
      : property?.realtor?.business_name || "the agent";

  return (
    <div className="w-full bg-slate-50 border border-slate-200/60 rounded-2xl p-5 text-slate-600 shadow-xs">
      <h3 className="font-semibold text-xs text-slate-800 tracking-wide uppercase mb-3">
        Disclaimer
      </h3>

      <div className="space-y-3 text-xs leading-relaxed text-slate-500">
        <p>
          The information displayed about this property comprises a property
          advertisement. FNP makes no warranty as to the accuracy or
          completeness of the advertisement or any linked information, and
          FindNigeriaProperties.com has no control over the content.
        </p>

        <p>
          This property listing does not constitute property particulars. The
          information is provided and maintained by{" "}
          <span className="font-semibold text-slate-700">{realtorName}</span>.
          FindNigeriaProperties.com shall not be held liable for the actions of
          any agent or property owner on or off this website.
        </p>
      </div>
    </div>
  );
};

export default PropDetailsDisclaimer;
